<template>
    <transition name="confirm-box">
        <div class="login-box im" v-show="login.sign_box_show || login.phone_box_show">
            <!--登录注册组件-->
            <transition name="confirm">
                <div :class="`login-main pr${login.sign_box_show ? ' slide-up' : ''}`" v-show="login.sign_box_show" @keyup.enter="sign">
                    <div class="tab-nav cb">
                        <div :class="`tab-nav-item fl${is_sign_in ? ' tab-nav-item-active' : ''}`" @click="login.is_sign_in = true">登录</div>
                        <div :class="`tab-nav-item fl${is_sign_in ? '' : ' tab-nav-item-active'}`" @click="login.is_sign_in = false">注册</div>
                    </div>

                    <div class="tab-nav-close" @click="login.sign_box_show = false">
                        <i class="icon-close"></i>
                    </div>

                    <div class="sign-input-box cb">
                        <el-select class="sign-select fl" filterable v-model="nation" placeholder="请选择">
                            <el-option v-for="(v, k) in countries" :key="k" :label="`${v.name} ${v.alias} +${v.code}`" :value="v.code">
                                <span class="fl">{{ v.name }}</span>
                                <span class="sign-select-option fl">{{ v.alias }}</span>
                                <span class="sign-select-option fl">+{{ v.code }}</span>
                            </el-option>
                        </el-select>
                        <input ref="phone" @focus="phoneTip = ''" v-model="phone" type="text" :class="`sign-input sign-input-phone${phoneTip ? ' sign-input-error' : ''}`" :placeholder="is_sign_in ? '请输入手机号' : '填写常用手机号'" maxlength="11">
                        <i v-show="phoneTip" @click="clear('phone')" class="icon-error" title="清空"></i>
                        <p class="sign-tip phone-tip">{{phoneTip}}</p>
                    </div>

                    <div class="sign-input-box cb" v-show="!is_sign_in">
                        <i class="sign-input-icon icon-user"></i>
                        <input ref="nico" v-model="nico" @focus="nicoTip = ''" type="text" :class="`sign-input sign-input-password${nicoTip ? ' sign-input-error' : ''}`" placeholder="昵称（3-16位字符组成）">
                        <i v-show="nicoTip" class="icon-error" @click="clear('nico')" title="清空"></i>
                        <p class="sign-tip">{{nicoTip}}</p>
                    </div>

                    <div class="sign-input-box" v-show="is_psw_login || !is_sign_in">
                        <i class="sign-input-icon icon-password"></i>
                        <input ref="psw" v-model="psw" @focus="pswTip = ''" :class="`sign-input sign-input-password${pswTip?' sign-input-error' : ''}`" :type="`${watch ? 'text' : 'password'}`" :placeholder="is_sign_in ? '请输入密码' : '密码（6-16位字符组成，区分大小写）'">
                        <i v-show="pswTip" @click="clear('psw')" class="icon-error" title="清空"></i>
                        <i v-show="!pswTip" @click="watch = !watch" :class="`watch-password ${watch ? 'icon-visible' : 'icon-hidden'}`" :title="`切换为${watch ? '隐藏' : '显示'}密码`"></i>
                        <p class="sign-tip">{{pswTip}}</p>
                    </div>

                    <div class="sign-input-box cb" v-if="!is_psw_login || !is_sign_in">
                        <i class="sign-input-icon icon-captcha"></i>
                        <div class="fl pr">
                            <input ref="captcha" v-model="captcha" @focus="cpcTip = ''" type="text" :class="`sign-input sign-input-captcha fl${cpcTip ? ' sign-input-error' : ''}`" placeholder="验证码" autocomplete="off">
                            <i v-show="cpcTip" @click="clear('captcha')" class="icon-error" title="清空"></i>
                        </div>
                        <img class="sign-img-captcha fr" :src="captchaSrc" @click="changeCaptcha" title="点击切换图片">
                        <p class="sign-tip">{{cpcTip}}</p>
                    </div>

                    <div class="sign-input-box cb" v-show="!is_psw_login || !is_sign_in">
                        <i class="sign-input-icon icon-msg"></i>
                        <div class="fl pr">
                            <input ref="code" v-model="code" @focus="codeTip = ''" :class="`sign-input sign-input-captcha fl${codeTip ? ' sign-input-error' : ''}`" type="text" placeholder="短信验证码" autocomplete="off">
                            <i @click="clear('code')" :class="`watch-password ${codeTip ? 'icon-error' : ''}`" title="清空"></i>
                        </div>
                        <span :class="`sign-btn sign-btn-captcha fl${cooldown ? ' disabled' : ''}`" @click="sendMsg">
                            <span v-show="!is_sending">{{`${cooldown ? '' : '点击'}${is_first_code ? '' : '重新'}获取${cooldown ? `(${cooldown}s)` : ''}`}}</span>
                            <span v-show="is_sending" class="sign-btn-loading"></span>
                        </span>
                        <p class="sign-tip">{{codeTip}}</p>
                    </div>

                    <div class="sign-btn-box">
                        <div class="sign-btn" @click="sign">
                            <span v-show="!is_signing">{{is_sign_in ? '登录' : '注册'}}</span>
                            <span v-show="is_signing" class="sign-btn-loading"></span>
                        </div>
                        <div class="sign-btn-tip cb" v-show="is_sign_in">
                            <span class="fl change-psw-login" @click="is_psw_login = !is_psw_login">手机{{is_psw_login ? '短信' : '密码'}}登录</span>
                            <span class="fr forget-password">忘记密码?</span>
                        </div>
                    </div>

                    <div class="sign-more" v-show="is_sign_in">
                        <h6 class="sign-more-title">其他登录方式</h6>
                        <div class="sign-more-icon">
                            <i class="cp icon-qq" @click="qq_frame_show = true"></i>
                            <i class="cp icon-wechat" @click="wechat_frame_show = true"></i>
                            <i class="cp icon-weibo" @click="weibo_frame_show = true"></i>
                        </div>
                    </div>
                </div>
            </transition>

            <!--绑定手机组件-->
            <transition name="confirm">
                <div :class="`login-main${login.phone_box_show ? ' slide-up' : ''}`" v-if="login.phone_box_show" @keyup.enter="bindPhone">
                    <div class="tab-nav cb">
                        <div class="tab-nav-item fl tab-nav-item-active">绑定手机</div>
                    </div>

                    <div class="tab-nav-close" @click="login.phone_box_show = false">
                        <i class="icon-close"></i>
                    </div>

                    <div class="sign-input-box cb">
                        <el-select class="sign-select fl" filterable v-model="nation" placeholder="请选择">
                            <el-option v-for="(v, k) in countries" :key="k" :label="`${v.name} ${v.alias} +${v.code}`" :value="v.code">
                                <span class="fl">{{ v.name }}</span>
                                <span class="sign-select-option fl">{{ v.alias }}</span>
                                <span class="sign-select-option fl">+{{ v.code }}</span>
                            </el-option>
                        </el-select>
                        <input ref="phone" @focus="phoneTip = ''" v-model="phone" type="text" :class="`sign-input sign-input-phone${phoneTip ? ' sign-input-error' : ''}`" :placeholder="is_sign_in ? '请输入手机号' : '填写常用手机号'" maxlength="11">
                        <i v-show="phoneTip" @click="clear('phone')" class="icon-error" title="清空"></i>
                        <p class="sign-tip phone-tip">{{phoneTip}}</p>
                    </div>

                    <div class="sign-input-box cb">
                        <i class="sign-input-icon icon-captcha"></i>
                        <div class="fl pr">
                            <input ref="captcha" v-model="captcha" @focus="cpcTip = ''" type="text" :class="`sign-input sign-input-captcha fl${cpcTip ? ' sign-input-error' : ''}`" placeholder="验证码">
                            <i v-show="cpcTip" @click="clear('captcha')" class="icon-error" title="清空"></i>
                        </div>
                        <img class="sign-img-captcha fr" :src="captchaSrc" @click="changeCaptcha" title="点击切换图片">
                        <p class="sign-tip">{{cpcTip}}</p>
                    </div>

                    <div class="sign-input-box cb">
                        <i class="sign-input-icon icon-msg"></i>
                        <div class="fl pr">
                            <input ref="code" v-model="code" @focus="codeTip = ''" :class="`sign-input sign-input-captcha fl${codeTip ? ' sign-input-error' : ''}`" type="text" placeholder="短信验证码">
                            <i @click="clear('code')" :class="`watch-password ${codeTip ? 'icon-error' : ''}`" title="清空"></i>
                        </div>
                        <span :class="`sign-btn sign-btn-captcha fl${cooldown ? ' disabled' : ''}`" @click="sendMsg">
                                <span v-show="!is_sending">{{`${cooldown ? '' : '点击'}${is_first_code ? '' : '重新'}获取${cooldown ? `(${cooldown}s)` : ''}`}}</span>
                                <span v-show="is_sending" class="sign-btn-loading"></span>
                            </span>
                        <p class="sign-tip">{{codeTip}}</p>
                    </div>

                    <div class="sign-btn-box" @click="bindPhone" @keyup.enter="bindPhone">
                        <div class="sign-btn" @click="sign">
                            <span v-show="!is_signing">确认绑定</span>
                            <span v-show="is_signing" class="sign-btn-loading"></span>
                        </div>
                    </div>

                </div>
            </transition>

            <!--提示组件-->
            <transition name="confirm">
                <div class="message-box im" v-show="phone_dialog_show">
                    <div class="message-box-mask" @click="phone_dialog_show = false"></div>
                    <transition name="slide">
                        <div class="message-box-main" v-if="phone_dialog_show">
                            <div class="message-header-box">
                                <div class="message-title">手机号已注册</div>
                                <i class="icon-close" @click="phone_dialog_show = false"></i>
                            </div>
                            <div class="message-content-box">
                                <i class="icon-warning">!</i>
                                <p class="message-text">检测到该手机号已注册, 是否继续将该手机绑定到此账号下?</p>
                            </div>
                            <div class="message-button-box">
                                <span class="message-button message-button-cancel" @click="phone_dialog_show = false">取消</span>
                                <span class="message-button" @click="confirmBind">确认</span>
                            </div>
                        </div>
                    </transition>
                </div>
            </transition>

            <!--第三方登陆组件-->
            <div class="sign-frame-box im" v-if="qq_frame_show || weibo_frame_show || wechat_frame_show">
                <div class="sign-frame-main sign-frame-qq" v-if="qq_frame_show">
                    <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101285374&redirect_uri=https://www.vhiphop.com/more-sign"></iframe>
                    <div class="qq-frame-header"></div>
                    <i @click="qq_frame_show = false" class="icon-close frame-qq-icon"></i>
                </div>

                <div class="sign-frame-main" v-if="weibo_frame_show">
                    <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://api.weibo.com/oauth2/authorize?client_id=1628876205&response_type=code&redirect_uri=https://www.vhiphop.com/more-sign"></iframe>
                    <i @click="weibo_frame_show = false" class="icon-close frame-wb-icon"></i>
                </div>

                <div class="sign-frame-main sign-frame-wechat" v-if="wechat_frame_show">
                    <iframe @load="signFrameLoad" ref="frame" class="sign-frame" src="https://open.weixin.qq.com/connect/qrconnect?appid=wx13820b959172c57f&redirect_uri=https%3A%2F%2Fwww.vhiphop.com%2Fmore-sign&response_type=code&scope=snsapi_login&self_redirect=true&style=white#wechat_redirect"></iframe>
                    <i @click="wechat_frame_show = false" class="icon-close frame-qq-icon"></i>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data: () => ({
            nation: '86',
            is_signing: false,
            is_sending: false,
            is_psw_login: true,
            qq_frame_show: false,
            weibo_frame_show: false,
            wechat_frame_show: false,
            watch: false,
            psw: '',
            code: '',
            captcha: '',
            phone:  '',
            phoneTip: '',
            hasPhone: false,
            phone_dialog_show: false,
            pswTip: '',
            cpcTip: '',
            codeTip: '',
            is_first: true,
            is_first_code: true,
            cooldown: 0,
            nico: '',
            nicoTip: '',
            captchaSrc: '',
        }),
        watch: {
            phone (e) {
                this.phoneTip = '';
                if (e.length === 11) {
                    // console.log(this.sign_box_show);
                    if (this.login.phone_box_show || (this.login.sign_box_show && !this.login.is_sign_in)) {// 绑定手机  或者 注册情景时触发检测
                        this.hasPhone = false;

                        this.api.get(`sign/phone/check/${e}`).then(() => {

                        }, e => {
                            if (e.status_code  === 1001) {
                                if (this.login.phone_box_show) {
                                    this.hasPhone = true;
                                } else {
                                    this.phoneTip = e.message;
                                }
                            }
                        })
                    }
                }
            },
            nico () {
                this.nicoTip = '';
            },
            psw () {
                this.pswTip = '';
            },
            captcha () {
                this.cpcTip = '';
            },
            code () {
                this.codeTip = '';
            },
        },
        methods: {
            showSignBox() {
                this.login.is_sign_in = false;
                this.login.sign_box_show = true;
            },
            clear(e) {
                this[e] = '';
                this.$refs[e].focus();
            },
            clearInput() {
                this.phone = this.nico = this.psw = this.captcha = this.code = '';
            },
            checkPhone() {
                if(isNaN(+this.phone) || this.phone.length < 6 || this.phone.length > 11) {
                    this.phoneTip = '请输入正确的手机号';
                    return false;
                }
            },
            checkPsw() {
                if (this.psw.length < 6 || this.psw.length > 16) {
                    this.pswTip = '密码不能小于6个字符或大于16个字符';
                }
            },
            checkCaptcha() {
                if (this.captcha.length !== 4) {
                    this.cpcTip = '请输入正确的验证码';
                }
            },
            checkCode() {
                if (isNaN(+this.code) || this.code.length !== 6) {
                    this.codeTip = '请输入正确的短信验证码';
                }
            },
            sendMsg() {
                let {api} = this;
                this.checkPhone();
                this.checkCaptcha();

                if (!this.is_first || this.cooldown || this.phoneTip || this.cpcTip) {
                    return false;
                }

                if (this.hasPhone) {// 检测是否已绑定手机
                    return this.phone_dialog_show = true;
                }

                this.is_first = false;
                this.is_sending = true;
                api.post('sign/msg', {code: this.captcha, nation: this.nation, phone: this.phone}).then(() => {
                    this.cooldown = 60;// 发送成功 进入冷却时间60s
                    let timer = setInterval(() => {
                        this.cooldown ? this.cooldown-- : clearInterval(timer);
                    }, 1000);
                    this.is_first = true;// 允许再次点击
                    this.is_sending = false;// 取消loading
                    this.code = '';
                    this.$refs['code'].focus();
                    this.is_first_code = false;// 不再是第一次获取
                }, this.signError)
            },
            changeCaptcha(e) {
                this.captcha = '';
                e.target.src += '?';
            },
            sign() {// 注册 登录控制器
                this.checkPhone(); // 检测手机格式
                if (this.is_sign_in) {
                    if (this.is_psw_login) {
                        this.checkPsw();
                        this.signInPsw();// 密码登录
                    } else {
                        this.signInMsg();// 短信登录
                    }
                } else {
                    this.signUp();// 注册
                }
            },
            signUp() {// 注册
                if (this.nico.length < 3 || this.nico.length > 16) {
                    this.nicoTip = '昵称不能小于3个字符或大于16个字符';
                }
                this.checkPsw();
                this.checkCaptcha();
                this.checkCode();

                if (!this.is_first || this.codeTip || this.phoneTip || this.nicoTip || this.pswTip || this.cpcTip) {
                    return false;
                }
                this.is_first = false;
                this.is_signing = true;

                this.api.post('sign/up', {nation: this.nation, phone: this.phone, nico: this.nico, psw: this.psw, code: this.code}).then(this.signSuccess, this.signError);
            },
            signSuccess(e) {// 登录成功后的回调
                let {user} = this;
                user.id = e.id;
                user.token = e.token;
                user.nico = e.nico;
                user.thumb = e.thumb;
                user.phone = e.phone;
                window.localStorage.user = JSON.stringify(user);// 存入localStorage
                this.login.sign_box_show = false;
                this.is_first = true;
                this.is_signing = false;// loading
                this.clearInput();
            },
            signError(e) {// 登录失败后的回调
                let {status_code, message} = e;
                switch (status_code) {
                    case 1001: this.phoneTip = message;break;
                    case 1002: this.nicoTip = message;break;
                    case 1003: this.pswTip = message;break;
                    case 1004:
                        this.cpcTip = message;
                        this.captchaSrc += '?';
                        break;
                    case 1005: this.codeTip = message;break;
                }
                this.is_sending = false;// 取消发送验证码按钮的loading
                this.is_first = true;// 取消重复锁
                this.is_signing = false;// 取消登录按钮的loading
            },
            signInPsw() {// 密码登录
                if (!this.is_first || this.phoneTip || this.pswTip) {
                    return false;
                }

                this.is_first = false;
                this.is_signing = true;// loading
                this.api.post('sign/in', {nation: this.nation, phone: this.phone, psw: this.psw}).then(this.signSuccess, this.signError);
            },
            signInMsg() {// 短信登录
                this.checkCaptcha();
                this.checkCode();

                if (!this.is_first || this.phoneTip || this.cpcTip || this.codeTip) {
                    return false;
                }
                this.is_first = false;
                this.is_signing = true;// loading

                this.api.post('sign/in/msg', {nation: this.nation, phone: this.phone, code: this.code}).then(this.signSuccess, this.signError);
            },
            signFrameLoad() {// 第三方登录
                let type, code;

                try  {
                    code = this.$refs['frame'].contentWindow.location.search.split('?code=')[1];
                } catch (e) {
                    return false;
                }

                if (this.qq_frame_show) {
                    this.qq_frame_show = false;
                    type = 'qq';
                } else if (this.wechat_frame_show) {
                    this.wechat_frame_show = false;
                    code = code.split('&state=')[0];// 没有state参数 所以去掉后缀
                    type = 'wechat';
                } else {
                    this.weibo_frame_show = false;
                    type = 'weibo';
                    if (!code) return;
                }

                this.is_signing = true;
                this.api.post(`sign/in/${type}`, {code}).then(this.signSuccess, this.signError);
            },
            bindPhone() {
                this.checkCaptcha();
                this.checkCode();

                if (!this.is_first || this.phoneTip || this.cpcTip || this.codeTip) {
                    return false;
                }

                this.is_first = false;
                this.is_signing = true;
                let {nation, phone} = this;

                this.api.post('sign/bind', {nation, phone, code: this.code}).then(() => {
                    this.user.nation = nation;
                    this.user.phone = phone.substr(0, 3) + '****' + phone.substr(7);
                    this.login.phone_box_show = false;
                    this.is_first = true;
                    this.is_signing = false;// loading
                    this.clearInput();
                }, this.signError);
            },
            confirmBind() {
                this.phone_dialog_show = false;
                this.hasPhone = false;
                this.sendMsg();
            }
        },
        computed: {
            login() {
                return this.$store.state.sign;
            },
            user() {
                return this.$store.state.user;
            },
            is_sign_in() {
                return this.login.is_sign_in;
            },
            countries() {
                return this.$store.state.countries;
            }
        },
        created() {
            this.captchaSrc = this.api.captchaImgHost;
        }
    }
</script>

<style scoped>
    @import "../../static/css/common/sign.css";
</style>



// WEBPACK FOOTER //
// src/common/TheSign.vue